import { __rest } from 'tslib';
import React from 'react';
import Icon from '@ant-design/icons';
import { I as IconBase } from '../IconBase-df74767e.js';

const IconComponent = (props, ref) => {
    const data = {
        tag: 'svg',
        attr: {
            version: '1.1',
            id: 'Capa_1',
            x: '0px',
            y: '0px',
            viewBox: '0 0 475.082 475.082',
            style: 'enable-background:new 0 0 475.082 475.082;',
        },
        child: [
            {
                tag: 'g',
                attr: {},
                child: [
                    {
                        tag: 'path',
                        attr: {
                            d: 'M461.667,31.691c-8.949-8.945-19.698-13.417-32.265-13.417H45.682c-12.562,0-23.317,4.471-32.264,13.417\r\n\t\tC4.473,40.638,0,51.389,0,63.952v347.173c0,12.566,4.473,23.318,13.418,32.264c8.947,8.946,19.701,13.419,32.264,13.419h383.72\r\n\t\tc12.566,0,23.315-4.473,32.265-13.419c8.945-8.945,13.415-19.697,13.415-32.264V63.952\r\n\t\tC475.082,51.389,470.612,40.638,461.667,31.691z M219.271,420.266H45.682c-2.474,0-4.615-0.907-6.423-2.707\r\n\t\tc-1.809-1.811-2.712-3.949-2.712-6.427V91.367h182.725V420.266z M438.536,411.125c0,2.478-0.903,4.62-2.71,6.427\r\n\t\tc-1.813,1.807-3.949,2.71-6.427,2.71H255.813V91.36h182.729v319.765H438.536z',
                        },
                    },
                ],
            },
            { tag: 'g', attr: {}, child: [] },
            { tag: 'g', attr: {}, child: [] },
            { tag: 'g', attr: {}, child: [] },
            { tag: 'g', attr: {}, child: [] },
            { tag: 'g', attr: {}, child: [] },
            { tag: 'g', attr: {}, child: [] },
            { tag: 'g', attr: {}, child: [] },
            { tag: 'g', attr: {}, child: [] },
            { tag: 'g', attr: {}, child: [] },
            { tag: 'g', attr: {}, child: [] },
            { tag: 'g', attr: {}, child: [] },
            { tag: 'g', attr: {}, child: [] },
            { tag: 'g', attr: {}, child: [] },
            { tag: 'g', attr: {}, child: [] },
            { tag: 'g', attr: {}, child: [] },
        ],
    };
    const { style } = props;
    const _a = style || {}, { fontSize, color: passColor } = _a, rest = __rest(_a, ["fontSize", "color"]);
    const size = fontSize || 16;
    const color = passColor;
    return (React.createElement(Icon, Object.assign({}, props, { style: rest, ref: ref, component: () => (React.createElement(IconBase, { color: color, size: size, data: data, overrideColor: true })) })));
};
const TwoColumnsLayoutOutlined = React.forwardRef(IconComponent);
TwoColumnsLayoutOutlined.displayName = 'TwoColumnsLayoutOutlined';

export { TwoColumnsLayoutOutlined };
